import { useState } from 'react';
import { Button } from '@mlm/ui';
import { endImpersonation } from '../lib/api';
import { useAuthStore } from '../lib/auth-store';
import { queryClient } from '../lib/query-client';

/**
 * QoL Slice 4 — sticky red banner shown whenever the current session is an
 * admin impersonating this user. Clicking "Return to admin" revokes the
 * impersonation session and points the browser back at the admin SPA.
 */
export function ImpersonationBanner() {
  const user = useAuthStore((s) => s.user);
  const clear = useAuthStore((s) => s.clear);
  const [ending, setEnding] = useState(false);

  if (!user?.impersonator) return null;

  async function returnToAdmin() {
    setEnding(true);
    await endImpersonation();
    clear();
    queryClient.clear();
    const adminUrl = import.meta.env.VITE_ADMIN_URL ?? 'http://localhost:5173';
    window.location.href = adminUrl;
  }

  return (
    <div className="sticky top-0 z-50 bg-destructive text-destructive-foreground px-4 py-2 text-sm flex items-center justify-between gap-3">
      <span>
        Acting as <strong>{user.email}</strong> — your actions are audit-logged under your admin
        account.
      </span>
      <Button
        size="sm"
        variant="outline"
        className="bg-background text-foreground"
        onClick={() => void returnToAdmin()}
        disabled={ending}
      >
        {ending ? 'Returning…' : 'Return to admin'}
      </Button>
    </div>
  );
}
